module.exports = __webpack_public_path__ + "img/battery_2purple.2dd7f005.png";